import { css } from '@/styled-system/css';

export const propertyCardFlexAreaStyles = css.raw({
  paddingBlockStart: 'PropertyCard.FlexArea.gap.dataWrapper-toFlexArea',
  paddingBlockEnd: 'PropertyCard.FlexArea.padding.vert',
  paddingInline: 'PropertyCard.FlexArea.padding.horz',
});
